import React from 'react'
import { Redirect } from 'react-router-dom'
import { useSite } from '../../util/sites'

/**
 * PVOnlyPage
 * - Wrap pages/components that should only be shown for sites with PV.
 * - If selected site is not set yet -> shows a loading placeholder.
 * - If selected site has is_no_PV -> redirects to /solar/bess.
 *
 * Usage:
 * <PVOnlyPage>
 *   <YourComponent />
 * </PVOnlyPage>
 *
 * Optionally pass selectedSite prop to override redux value:
 * <PVOnlyPage selectedSite={site}>...</PVOnlyPage>
 */
export default function PVOnlyPage({ children }) {

  const selectedSite = useSite().selectedSite?.value;

  if (!selectedSite) {
    return <div>Loading...</div>
  }

  const isNoPV = selectedSite.is_no_PV;

  if (isNoPV) {
    return <Redirect to="/solar/bess" />
  }

  return <>{children}</>
}